export enum ROLE {
  ADMIN = 'admin',
  ACCOUNTANT = 'accountant',
  USER = 'user',
  SYSTEM = 'system',
  B2B_USER = 'b2b_user',
}
